var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoOk(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico_ok",
    transform: "translate(-4 -4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16502",
    "data-name": "Path 16502",
    d: "M25.8,39.971a1.714,1.714,0,0,0,1.311.6h0A1.716,1.716,0,0,0,28.42,39.9L41.612,22.76a1.714,1.714,0,0,0-2.717-2.091h0L27,36.1l-6.1-7.174a1.714,1.714,0,1,0-2.571,2.22Z",
    transform: "translate(-1.963 -2.286)",
    fill: "#00852a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16503",
    "data-name": "Path 16503",
    d: "M28,52A24,24,0,1,0,4,28,24,24,0,0,0,28,52ZM28,7.429A20.571,20.571,0,1,1,7.429,28,20.571,20.571,0,0,1,28,7.429Z",
    fill: "#00852a"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoOk);
export default __webpack_public_path__ + "static/media/ico_ok.d209ecbc.svg";
export { ForwardRef as ReactComponent };